import restClient from "../restClient";

export const getCustomerQR = async (id) => {
  try {
    const response = await restClient.get(`customer-qrs/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateCustomerQR = async (id, data) => {
  try {
    const response = await restClient.put(`customer-qrs/${id}`, { data });
    return response.data;
  } catch (err) {
    console.error('Error updating customer QR:', err);
    throw err;
  }
};

